import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent {
  private _modal = inject(NgbActiveModal);

  title = 'Are you sure?';
  message = 'Placeholder: Please, enter a message.';
  confirmBtnText = 'Ok';
  style: 'danger' | 'success' = 'danger';
  icon: string | null = null;

  dismiss() {
    this._modal.dismiss();
  }

  confirm() {
    this._modal.close();
  }
}
